export const ar = {
  wifi: {
    signIn: 'تسجيل الدخول',
    setParameters: 'تعيين المعلمات',
    welcomeGuest: 'مرحبا بالضيف!',
    welcomeUser: `مرحبا {{name}}!`,
    youAreNowConnected: 'أنت متصل الآن',
    pleaseSignIn: 'يرجى تسجيل الدخول للوصول إلى الإنترنت.',
    welcomeAbroad: 'مرحبا بك على متن السفينة!',
    wifiAdventure:
      'قريباً ستتصفح أمواج الويب العظيمة مثل قبطان متمرس. لا توجد أسماك قرش رقمية في الأفق - فقط إبحار سلس في المستقبل!',
    waitingForWifi: 'نحن نقوم بتكوين الاتصال ...',
    wifiPortal: 'بوابة الواي فاي',
    langEn: 'الإنجليزية',
    langAr: 'العربية',
    wifiTestConfig: 'اختبار تكوين الواي فاي (فقط للتطوير)',
    goToLoginPage: 'انتقل إلى صفحة تسجيل الدخول مع المعلمات',
    authSignInError:
      'خطأ أثناء تسجيل الدخول إلى شبكة الواي فاي، المستخدم غير مصرح له، حاول مرة أخرى لاحقًا أو اتصل بالدعم',
    authSignInSuccess: 'تم تسجيل الدخول بنجاح',
    wifiTestConfigEnterGuestMAC: 'أدخل MAC الضيف (مطلوب)',
    wifiTestConfigEnterAPMAC: 'أدخل AP MAC',
    wifiTestConfigEnterSSID: 'أدخل SSID',
    wifiTestConfigEnterTimeInMinutes: 'أدخل الوقت بالدقائق',
    sitesDashboardTitle: 'لوحة المواقع',
    sitesDashboardTotalSites: 'إجمالي المواقع',
    sitesDashboardWithLogo: 'مع الشعار',
    sitesDashboardWithoutLogo: 'بدون شعار',
    sitesDashboardLaunched: 'تم الإطلاق',
    sitesDashboardNotLaunched: 'لم يتم الإطلاق',
    sitesDashboardSearchPlaceholder: 'البحث في المواقع بالاسم أو الوصف...',
    sitesDashboardFilterAll: 'جميع المواقع',
    sitesDashboardFilterLaunched: 'المُطلقة فقط',
    sitesDashboardFilterNotLaunched: 'غير المُطلقة فقط',
    sitesDashboardFilterWithLogo: 'مع الشعار',
    sitesDashboardTableLogo: 'الشعار',
    sitesDashboardTableCode: 'رمز الموقع',
    sitesDashboardTableDescription: 'الوصف',
    sitesDashboardTableAccessPoints: 'نقاط الوصول',
    sitesDashboardTableStatus: 'الحالة',
    sitesDashboardNoResults: 'لم يتم العثور على مواقع تطابق معايير البحث الخاصة بك.',
    sitesDashboardLoginRequired: 'يرجى تسجيل الدخول للوصول إلى لوحة المواقع.',
    customFields: {
      name: {
        label: 'الاسم الكامل',
        placeholder: 'أدخل اسمك الكامل',
        errorMessages: {
          required: 'الاسم مطلوب للتوصيل',
          minLength: 'يجب أن يكون الاسم حرفين على الأقل',
        },
      },
      communicationEmail: {
        label: 'البريد الإلكتروني للتحديثات',
        placeholder: 'example@email.com',
      },
    },
    profileLoadError: 'فشل في تحميل الملف الشخصي',
    profileUpdateError: 'فشل في تحديث الملف الشخصي',
  },
};
